export default __webpack_public_path__ + "static/media/LI.8962ced7.svg";